import React from 'react';
import { ArrowIcon } from '../icons';

interface CardCarouselControlsProps {
  scroll: (direction: 'left' | 'right') => void;
}

function CardCarouselControls({ scroll }: CardCarouselControlsProps) {
  return (
    <>
      <div className="absolute h-full flex left-[-15px] z-10">
        <ArrowIcon
          onClick={() => scroll('left')}
          className="w-5 h-5 my-auto transform rotate-180 cursor-pointer text-neutral-200"
        />
      </div>
      <div className="absolute h-full  right-[-15px] flex z-10">
        <ArrowIcon
          onClick={() => scroll('right')}
          className=" w-5 h-5 my-auto cursor-pointer text-neutral-200"
        />
      </div>
    </>
  );
}

export default CardCarouselControls;
